import { useContext } from "react";

import { useAppSelector } from "app/hooks";
import SelectedStationContext from "app/SelectedStationContext";

export const useSelectedLab = () => {
  const selectedStation = useContext(SelectedStationContext);
  const lab = useAppSelector(({ labs }) => labs[selectedStation?.labId || 0]);

  if (!selectedStation?.labId) throw new Error("No Lab selected");
  if (!lab) throw new Error("Selected Lab could not be found");

  return lab;
};

export const useSelectedLabStation = () => {
  const selectedStation = useContext(SelectedStationContext);
  const labStation = useAppSelector(
    (state) => state.labStations[selectedStation?.stationId || 0]
  );

  if (!selectedStation?.labId) throw new Error("No Lab selected");
  if (!selectedStation?.stationId) throw new Error("No Lab Station selected");
  if (!labStation) throw new Error("Selected Lab Station could not be found");
  if (labStation.lab_id !== selectedStation.labId)
    throw new Error("Selected Lab Station does not belong to selected Lab");

  return labStation;
};
